/***** LOCALSTORAGE KEYS *****/
export const SERVICE_TOKEN = 'serviceToken'
export const PRODUCT_CATEGORY_TREE = 'productCategoryTrees'
export const SERVICE_TOKEN_EXPIRES_IN = 'serviceTokenExpiresIn'
export const ANONYMOUS_TOKEN = 'anonymousToken'
export const ANONYMOUS_TOKEN_EXPIRES_IN = 'anonymousTokenExpiresIn'
export const CUSTOMER_TOKEN = 'customerToken'
export const CUSTOMER_TOKEN_EXPIRES_IN = 'customerTokenExpiresIn'
export const TENANT = 'tenant'
export const ACCESS_TOKEN = 'accessToken'
export const CART_PRODUCT = 'cartProductList'
export const SESSION_ID = 'sessionId'
export const LOCATION_LIST = 'locationList'
export const CURRENCY_CODE = 'currency'
export const SAAS_TOKEN = 'saasToken'
export const USER = 'user'
export const APPLICATION_ID = 'applicationId'
export const INDEX_NAME = 'indexName'
export const SEARCH_KEY = 'searchKey'
export const EXTERNAL_CUSTOMER_TOKEN = "externalCustomerToken"
export const EXTERNAL_SAAS_TOKEN = "externalSaasToken"
export const EXTERNAL_TOKEN_EXPIRIES_IN = "externalTokenExpiresIn"
export const PROCUREMENT_SYSTEM_URL = 'procurementSystemUrl'
export const PREVIEW = 'preview'
export const REFRESH_TOKEN = 'refreshToken'
export const REFRESH_TOKEN_EXPIRES_IN = 'refreshTokenExpiresIn'

export const CLIENT_ID = 'clientId'
export const CHATBOT_SESSION_ID = 'chatbot-session-id'
